import React from "react";
import { format, isValid, parseJSON } from "date-fns";
import styled from "@emotion/styled";
import { Link, Typography, ListItemButton, useTheme } from "@mui/material";
import CalendarIcon from "@icons/myicons/calendar-paper.svg?react";

export interface NewsItemProps {
  title?: string;
  date?: string;
  link?: string;
  origin?: string;
  description?: string;
}

const NewsItemStyled = styled(ListItemButton)`
  flex-direction: column;
  align-items: baseline;

  &:hover {
    background-color: ${({ theme }) => theme.palette.background.subtle};
    border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  }
`;

const MetaItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

export const NewsItem = ({ date, title, link, description }: NewsItemProps) => {
  const theme = useTheme();
  const parsedDate = date ? parseJSON(date) : null;
  const formattedDate =
    parsedDate && isValid(parsedDate) ? format(parsedDate, "dd.MM.yyyy") : null;

  const content = (
    <NewsItemStyled>
      {formattedDate && (
        <MetaItemContainer>
          <CalendarIcon color={theme.palette.icon.tertiary} />
          <Typography variant="body2" color="textSecondary">
            {formattedDate}
          </Typography>
        </MetaItemContainer>
      )}
      <Typography variant="body2">{title}</Typography>
      {description && <Typography variant="body3">{description} </Typography>}
    </NewsItemStyled>
  );

  return link ? (
    <Link
      href={link}
      color="inherit"
      underline="none"
      target="_blank"
      rel="noopener noreferrer"
    >
      {content}
    </Link>
  ) : (
    content
  );
};
